import { Link } from 'react-router-dom';
import EmailThread from '../EmailThread';
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { FormGroup, Input, Label } from 'reactstrap';
import { RootState } from '../../../../../ReduxToolkit/Store';
import { Badges, LI, P, UL } from '../../../../../AbstractElements';
import { handleEnvelope, handleInterview } from '../../../../../ReduxToolkit/Reducers/LetterBoxReducer';
import { trashEmailData } from '../../../../../Data/Applications/LetterBox';
import DashboardSvgIcon from '../../../../../Utils/CommonComponents/DashboardSvgIcon';
import { fieldEmail } from "../../../../../Features/letterBox/api/types";
import MailPagination from '../InboxTab/Pagination';

type LetterBoxNavContentType = {
  listEmail: fieldEmail[];
  n_pages: number;
  isLoading: boolean;
};

export default function TrashTab({listEmail, n_pages, isLoading}:LetterBoxNavContentType) {
    const dispatch = useDispatch();
    const { faIcon } = useSelector((state: RootState) => state.email);
    const [fill, setFill] = useState(false)
    const handleValue = () => dispatch(handleInterview(true))

    const renderRow = (item: fieldEmail, threadToggle?: React.ReactNode) => (
<LI key={item.id} style={item.typeID === 2 ? { backgroundColor: "#ffffe9" } : undefined}>
                               <div className="inbox-user" style={{ minWidth: 0, flexShrink: 0, marginRight: 16 }}>
                            {threadToggle}
                                   <FormGroup className="m-0" check inline>
                                       <Input  name="emailCheckbox" id={`emailCheckbox${item.id}`} type="checkbox" />
                                       <Label check htmlFor={`emailCheckbox${item.id}`} />
                                   </FormGroup>
                                   
                               {item.ticketID && (<span className="text-nowrap" style={{ cursor: "text", userSelect: "text" }} onClick={event => event.stopPropagation()} onDoubleClick={event => event.stopPropagation()}>{item.ticketID}</span>)}
                        </div>
                               <div className="inbox-message" style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
                                   <div className="email-data" style={{ flex: 1, minWidth: 0 }}>
                                       <span>
                                           {item.subject}
                                           
                                       </span>
                                    <P className="mb-0 text-truncate">{item.from_email}</P>
                                   
                                   </div>
                                   {item.progettoID != null && item.attivitaID != null && item.progettoID > 0 && item.attivitaID > 0 && (
                                <Link
                                    className="btn btn-sm btn-outline-primary text-nowrap"
                                    style={{ flexShrink: 0, alignSelf: "center" }}
                                    to={`${process.env.PUBLIC_URL || ''}/progetti/${item.progettoID}/${item.attivitaID}`}
                                    onClick={event => event.stopPropagation()}
                                >
                                    Vai al task
                                </Link>
                            )}
                            <div className="email-timing" style={{ flexShrink: 0, justifyContent: "flex-end", whiteSpace: "nowrap" }}><span>{item.data_ins}</span></div>
                                   <div className="email-options">
                                       <i className={`fa-regular fa-envelope envelope-1 ${!faIcon ? "show" : "hide"}`} onClick={() => dispatch(handleEnvelope(true))} />
                                       <i className={`fa-solid fa-envelope-open-text envelope-2 ${faIcon ? "show" : "hide"}`} onClick={() => dispatch(handleEnvelope(false))} />
                                       <i className="fa-solid fa-print" />
                                   </div>
                            {item.typeID === 2 && (
                                <span className="text-primary d-inline-flex align-items-center" style={{ flexShrink: 0 }} title="Inviata da noi" role="img" aria-label="Inviata da noi">
                                    <i className="fa-solid fa-paper-plane" aria-hidden="true" />
                                </span>
                            )}
                               </div>
                           </LI>
    );

    return (
       <div className="mail-body-wrapper">
                   <UL className='simple-list'>
                       {listEmail.map(item => <EmailThread key={item.id} email={item} renderRow={renderRow} />)}
                   </UL>
                   <MailPagination n_pages={n_pages} />
               </div>
    )
}